import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=cdaea130&scoped=true&"
import script from "./AddNews.vue?vue&type=script&lang=js&"
export * from "./AddNews.vue?vue&type=script&lang=js&"
import style0 from "./AddNews.vue?vue&type=style&index=0&id=cdaea130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaea130",
  null
  
)

component.options.__file = "AddNews.vue"
export default component.exports